<template>
<div class="hello screen-spacing">
   <div class="">
        <div class="h1 display-inline">Current Order</div>
    </div>
       <SelectVenue class="mb-3" ref="venueDropDown" @updateVenue="updateVenue"/>
       <SelectBar v-if="venue_id!='' && venue_id!='0'" :venueId="venue_id" :liveOrder='true' class="mb-3" ref="barDropDown" @updateBar="updateBar" />


    <div  v-if="bar_id != '' && displayTotalCount" style="display: flex; justify-content: space-between; align-items: center; margin-top: 1rem;">
  <button class="btn btn-dark mb-2" @click="cancelAllRemainingOrders">Cancel All Orders</button>
  <div><strong> Showing {{ orders.length }} of {{ displayTotalCount }} total orders</strong></div>
  
</div>

    <div class="row header" v-if="bar_id!=''" style="background-color: purple;">
      <div class="col-md-2">{{getButtonHeader()}}</div>
      <div class="col-md-3 d-none d-md-block">Order_ID</div>
      <div class="col-md-1 d-none d-md-block"># of items</div>
      <div class="col-md-3 d-none d-md-block">Cost</div>
      <div class="col-md-3 d-none d-md-block">Time of order</div>
    </div>
    <div class="row py-2" v-for="(order, index) in orders" :key="index" :class="{ 'contact-us': order.is_accepted==true }">
      <div class="col-md-2">
        <button  type="button" class="btn text-bg-dark me-2"  v-on:click="openModal(order)">{{getButtonText(order)}}</button>
        <button v-if="order.is_accepted==true" type="button" class="btn btnSubmit d-none d-md-block"  v-on:click="completeOrder(order)">Complete</button>
        </div>
      <div class="col-md-3 d-none d-md-block">{{ order.readable_ID }}</div>
      <div class="col-md-1 d-none d-md-block">{{ numberofItems(order.item_list) }}</div>
      <div class="col-md-3 d-none d-md-block">{{ toDollarAmount(order.total_cost) }}</div>
      <div class="col-md-3 d-none d-md-block">{{ formatDate(order.createdAt) }}</div>
    </div>
    <!-- Modal -->
<div class="modal fade" id="orderListModal" ref="modal" tabindex="-1" aria-labelledby="orderList" aria-hidden="true">
  <CheckoutOrder :order="currentOrder" :bar_id="bar_id" :tableName="currentTableName" @completeOrder="completeOrder" @acceptOrder="acceptOrder" @acceptModifiedOrder="acceptModifiedOrder"  @cancelOrder ="cancelOrder" @declineOrder="declineOrder" @pingOrder ="pingOrder"/>
</div>
<button v-show="false" type="button" ref="action" data-bs-toggle="modal" data-bs-target="#orderListModal" > <i class="fa-solid fa-plus"></i></button>
  </div>

  
</template>

<script>
import SelectVenue from "../../components/SelectVenue.vue"
import SelectBar from "../../components/SelectBar.vue"
import CheckoutOrder from "../../components/modals/ViewOrder.vue"
import orderService from "../../api/orders.js"
import tableService from "../../api/table.js"
import Vue from 'vue'
import swal from 'sweetalert'; 
export default {
  components: {
    CheckoutOrder,
    SelectVenue,
    SelectBar
  },
  data() {
    return {
      orders: [],
      venue_id: "",
      bar_id: "",
      socket: null, // Initialize socket variable
      newOrdersWaiting:false,
      loading:false,
      currentOrder:"",
      intervalId: null,
      reconnect:false,
      screenWidth: window.innerWidth,
      totalCount:0,
      tables: [] // venue's tables, loaded only when "Table Orders" is selected

    };
  },
  mounted() {
    // Connect to WebSocket server
    

    // Periodically reload data every 2 minutes
    this.intervalId = setInterval(() => {
      this.reloadData();
    }, 600000); // 2 minutes in milliseconds
  },
   created() {
    window.addEventListener('resize', this.updateScreenWidth);
  },
  destroyed() {
    window.removeEventListener('resize', this.updateScreenWidth);
  },
  watch: {
  reconnect(newValue) {
    if (newValue) {
      // Trigger the alert when reconnect is set to true
       
    swal({
  title: 'Your screen has gone idle. Please refresh the screen',
  icon: 'warning',
  buttons: {
    confirm: {
      text: 'Refresh',
      value: true,
      visible: true,
      className: 'btn btn-primary',
      closeModal: false
    }
  }
}).then((value) => {
  if (value) {
    window.location.reload()
  }
});
    }
  }
},
  methods: {
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    getButtonHeader(){
       return this.screenWidth < 768 ? 'Order Actions' : '-';
    },
    getButtonText(order) {
      return this.screenWidth < 768 ? order.readable_ID : 'Open';
    },
    numberofItems(itemList) { 
      let items = 0;
      for (let iter = 0; iter < itemList.length; iter++) {
        if (!itemList[iter].removed) {
          items += itemList[iter].numberOfDrinks || 0;
        }
      }
      return items;
    },
   dateToTime(date){ 
      return date.toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric'
    });},
    toDollarAmount(value){
      return '$' + (value*.01).toFixed(2)
    },
    formatDate(rawDate){
     // var date = new Date(rawDate);
      const dateString =rawDate;
      const localDate = new Date(dateString);


      return this.dateToTime(localDate);
    },
    async acceptModifiedOrder(e){
      const body = {
        ...e,
        currentServingBar: this.bar_id
      };
      await orderService.acceptModifiedOrder(e._id, body).then(object =>{
        console.log('davion accepts')
        
        const data = object.data
        console.log(data)// if success
        if(data._id != null && object.status== "success"){  
          const index = this.orders.findIndex(item => item._id === e._id);
          console.log(index)
          console.log(this.orders[index])
          Vue.set(this.orders, index, data);
        }  
        else if(data._id != null){
            this.orders = this.orders.filter(item => item._id !== e._id);
            this.totalCount--;
         }   
       });
    },
    async acceptOrder(e){
      await orderService.acceptOrder(e._id, e).then(object =>{
        console.log('davion accepts')

        const data = object.data
        console.log(data)// if success
        if(data._id != null && object.status== "success"){  
          const index = this.orders.findIndex(item => item._id === e._id);
          console.log(index)
          console.log(this.orders[index])
          Vue.set(this.orders, index, { ...this.orders[index], is_accepted: true });
        }
        else if(data._id != null){
            this.orders = this.orders.filter(item => item._id !== e._id);
            this.totalCount--;
         }
        
       });
    },
    async completeOrder(e){
      swal({
  title: 'Are you sure you want to complete this order',
  text: 'This means the customer has successfully received their order',
  buttons: {
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
  closeOnClickOutside: false,
}) .then(async(value) => {
  if(value){
      const submitOrder = {...e, userID: sessionStorage.getItem('isBusiness') === "true"? null: sessionStorage.getItem('user')}
    await orderService.completeOrder(e._id, submitOrder).then(data =>{
        console.log(data)// if success
         if(data.order._id != null){
            this.orders = this.orders.filter(item => item._id !== e._id);
            this.totalCount--;
            if(!data.tipSuccess){
              swal('Your order completed, but your tip was not proccessed. Screenshot the following. Order_ID: '+data.readable_ID+', Tip: '+data.stripe_tip_amount, {
        icon: 'success',
      });
            }
            else{
              swal('Your order completed!', {
        icon: 'success',
      });
            }

        
         }
       });
  }
})
      
    },
    async declineOrder(e){
      await orderService.declineOrder(e.orderID, e.barID).then(data =>{
        console.log(data)
        console.log(data._id != null)
        if(data._id != null){
          console.log('deleted');
          swal('Your order has been declined!', {
        icon: 'success',
      });
           this.orders = this.orders.filter(item => item._id !== e.orderID);
           this.totalCount--;
        }
         
       });
    },
    async cancelOrder(e){
      const cancelledOrder = {...e, venue:true}
      //todo Set the object body to just have cancel reason and the update_ID
       await orderService.cancelOrder(e._id, cancelledOrder).then(data =>{
        console.log(data)
        console.log(data._id != null)
        if(data._id != null){
          console.log('deleted');
          swal('Your order has been deleted!', {
        icon: 'success',
      });
           this.orders = this.orders.filter(item => item._id !== e._id);
           this.totalCount--;
        }
         
       });
    },
    async cancelAllRemainingOrders(){
      swal({
  title: `Are you sure you want to cancel ${this.orders.length} order(s)?`,
  text: 'Only do this if the venue is closing',
  buttons: {
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
  closeOnClickOutside: false,
}) .then(async(value) => {
  if(value){
    await orderService.cancelAllRemainingOrders(this.venue_id,this.bar_id).then(data =>{
        console.log(data)// if success
        if(data.status==="success"){
          swal('Your bar is closed!', {
        icon: 'success',
      });
      this.bar_id=""
      this.venue_id=""
      this.orders=[]
      this.socket.send(JSON.stringify({ event: 'closeConnection', data: this.bar_id }));
       this.socket.close(1000, "Manual close");
        }  
       });
  }
})
    },
    async pingOrder(e){
      const pingedOrder = {...e, venue:true}
      //todo Set the object body to just have cancel reason and the update_ID
       await orderService.pingOrder(e._id, pingedOrder).then(data =>{
        console.log(data)
        console.log(data._id != null)
        if(data._id != null){
          console.log('pinged');
          swal('Your order has been pinged!', {
        icon: 'success',
      });
        }  
       });
    },
    openModal(item){
      this.currentOrder=item;
      this.$refs.action.click();
      // A table added after the list was loaded won't be found yet, so refresh the list once
      if (this.isTableOrders && item.location_ID && !this.currentTableName) {
        this.loadTables();
      }
    },
    async loadTables(){
      if (!this.isTableOrders) {
        this.tables = [];
        return;
      }
      try {
        const data = await tableService.getAllTables(this.venue_id);
        this.tables = Array.isArray(data) ? data : [];
      } catch (err) {
        console.error('Could not load tables', err);
        this.tables = [];
      }
    },
    updateVenue(e) {
      this.venue_id = e.target.value;

      if (this.bar_id !== '') {
        this.socket.send(JSON.stringify({ event: 'closeConnection', data: this.bar_id }));
        this.socket.close(1000, "Manual close");
      }

      this.bar_id = '';
      this.orders = [];
      this.tables = [];

      // Check if venue uses Stripe for payments
      const selectedVenue = this.$store.state.venues.find(v => v._id === this.venue_id);

      if (selectedVenue?.useStripeForPayments) {
        const stripeAccountCreated = sessionStorage.getItem('stripeAccountCreated');
        if (stripeAccountCreated === 'false') {
          swal({
            title: "Stripe Tips Disabled",
            text: "You will not receive any tips until your Stripe account is connected. Go to Settings to connect your Stripe account.",
            icon: "warning",
            button: "Got it"
          });
        }
      }

      // You can still fetch the menu or other related actions here if needed
    },
    async updateBar(e){
      if(this.bar_id!=''){
        this.socket.send(JSON.stringify({ event: 'closeConnection', data: this.bar_id }));
       this.socket.close(1000, "Manual close");
      }
      this.bar_id = e.target.value
      console.log(typeof(this.bar_id))
      this.loadTables()
      this.reconnect = false
      await this.connectWebsocket()

    },
    async connectWebsocket(){
      console.log("Start connection")
      this.socket = new WebSocket(`${process.env.VUE_APP_WEB_SOCKET_URL}?entityId=${this.bar_id}&venueId=${this.venue_id}`);

      
    // WebSocket open event
    this.socket.addEventListener('open', (event) => {
      console.log('WebSocket connection opened:'+event);

      // Send a message to the server
      //this.socket.send('Hello from Vue.js!');
    });

    // WebSocket message event
    this.socket.addEventListener('message', (event) => {
      const data = JSON.parse(JSON.parse(event.data));
      console.log(data)

      // Handle different events
      switch (data.event) {
        case 'newOrder': {
          console.log('Dave in the switch')
          if (this.orders.length < 20) {
            this.orders.push(data.order);
          } else {
            this.newOrdersWaiting = true;
          }
          this.totalCount++
          break;
        }
        case 'cancelOrder': {
          console.log('Cancelled Order:')
          console.log(data.event)
          const orderIdToRemove = data.order._id;
          const indexToRemove = this.orders.findIndex(item => item._id === orderIdToRemove);
0
          // Check if the item was found
          if (indexToRemove !== -1) {
            // Remove the item using splice
            this.orders.splice(indexToRemove, 1);
            console.log(`Order with ID ${orderIdToRemove} cancelled.`);
            this.totalCount--;
          } else {
            console.log(`Order with ID ${orderIdToRemove} not found.`);
          }
          break;
        }
        case 'orderUpdate':
          console.log(`Item updated`);
          break;
        default:
          // Handle other events if needed
          break;
      }

    });

    // WebSocket close event
    this.socket.addEventListener('close', (event) => {
      console.log('WebSocket connection closed:');
      console.log(event)
      if (event.code === 1000) {
        console.log("WebSocket closed manually.");
       
    } else {
        console.log(`WebSocket closed unexpectedly with code ${event.code}`);
        this.reconnect = true
    }
      
    });
    console.log("Get the orders")
    await orderService.getAllPendingOrders(this.venue_id, this.bar_id).then(data =>{
      console.log("recieved:")
      console.log(data)
      this.orders = data.items
    });
    },
    async reloadData() {
      if(this.bar_id != ''){        
       await orderService.getAllPendingOrders(this.venue_id, this.bar_id).then(data =>{
         this.orders = data.items
       });
      }
    },
  },
  computed:{
    // "Table Orders" in the location dropdown uses the venue's ID as its value
    isTableOrders(){
      return this.bar_id !== '' && String(this.bar_id) === String(this.venue_id);
    },
    // Name of the table this order is served to, matched on order.location_ID === table._id
    currentTableName(){
      if (!this.isTableOrders || !this.currentOrder || !this.currentOrder.location_ID) return '';
      const table = this.tables.find(t => String(t._id) === String(this.currentOrder.location_ID));
      return table ? table.name : '';
    },
    displayTotalCount(){
      if(this.totalCount>0){
        return this.totalCount
      }
      else if(this.totalCount<this.orders.length){
        return this.orders.length
      }
      return 0;
    }
  },
  beforeDestroy() {
    // Close WebSocket connection when the component is destroyed
    if (this.socket) {
      this.socket.close();
    }
     clearInterval(this.intervalId);
  },   
};
</script>


<style>
.header {
  font-weight: bold;
  color: white;
}
</style>